export default __webpack_public_path__ + "static/media/uwaterloo.79fad263.jpg";